/**
 * @generated SignedSource<<7f6c85606ef6e78aa046227e2217f186>>
 * @relayHash c1dd849aced17a5813f628a75f184136
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c1dd849aced17a5813f628a75f184136

import { ConcreteRequest } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type HealthInformationStatus = "NONE" | "SOME" | "UNKNOWN";
export type De_updateAllPatientAllergiesInput = {
  allergies: ReadonlyArray<AllergyInput>;
  allergyStatus?: HealthInformationStatus | null;
  patientId: string;
};
export type AllergyInput = {
  comment?: string | null;
  diagnosisCode: string;
  id?: string | null;
};
export type deUpdateAllPatientAllergiesMutation$variables = {
  input: De_updateAllPatientAllergiesInput;
};
export type deUpdateAllPatientAllergiesMutation$data = {
  readonly updateAllPatientAllergies: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly patientAllergiesOutput: {
      readonly allergies: ReadonlyArray<{
        readonly comment: string | null;
        readonly icdDiagnosis: {
          readonly associationType: AssociationType | null;
          readonly diagnosisCode: string;
          readonly id: string;
          readonly isAssociation: boolean;
          readonly primaryCode: string | null;
          readonly secondaryCode: string | null;
          readonly text: string;
        };
      }>;
      readonly id: string;
      readonly status: HealthInformationStatus;
    } | null;
  };
};
export type deUpdateAllPatientAllergiesMutation = {
  response: deUpdateAllPatientAllergiesMutation$data;
  variables: deUpdateAllPatientAllergiesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "IcdCodeNotUnique",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUpdateAllPatientAllergiesMutation",
    "selections": [
      {
        "alias": "updateAllPatientAllergies",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateAllPatientAllergiesPayload",
        "kind": "LinkedField",
        "name": "de_updateAllPatientAllergies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "patientAllergiesOutput",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergyOutput",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUpdateAllPatientAllergiesMutation",
    "selections": [
      {
        "alias": "updateAllPatientAllergies",
        "args": (v1/*:: as any*/),
        "concreteType": "De_updateAllPatientAllergiesPayload",
        "kind": "LinkedField",
        "name": "de_updateAllPatientAllergies",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientAllergiesOutput",
            "kind": "LinkedField",
            "name": "patientAllergiesOutput",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergyOutput",
                "kind": "LinkedField",
                "name": "allergies",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c1dd849aced17a5813f628a75f184136",
    "metadata": {},
    "name": "deUpdateAllPatientAllergiesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "972631dcbd6e0780baf1211ae1a3b7fe";

export default node;
